import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { setNavigator } from "./navigationService";

export default function RouterNavigatorBinder() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return null;
}
